import { render, staticRenderFns } from "./149.vue?vue&type=template&id=60d8bc2e&scoped=true&"
var script = {}
import style0 from "./149.vue?vue&type=style&index=0&id=60d8bc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d8bc2e",
  null
  
)

export default component.exports